import StandardSection from 'components/OrderConfirmation/SddSections/StandardSection/StandardSection';
import withStandardSectionProps from 'viewModel/orderConfirmation/sddSections/standardSection/withStandardSectionProps';

const ConnectedStandardSection = withStandardSectionProps(StandardSection);

export default ConnectedStandardSection;
